import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { LabelKey } from '@/lib/label-keys';

/** v0.4 章③ (D-29/D-67/D-70): テナント別ラベル override の取得 + フォールバック解決。
 *  設計: docs/design/v04-shift-labor-management-detail.md §3-5
 *
 *  ⚠️ 最優先事項 (D-70 必須要件③): `/labels` が未取得・失敗しても呼び出し側の fallback で
 *  描画できること。ここが効かないと既存画面全域が回帰対象になる。そのためこのフックは
 *  認証ガードや try/catch を持たず、`data` が undefined のまま fallback へ素通りする
 *  TanStack Query の既定挙動 (未ログイン時は /labels が 401 → data は undefined のまま) に委ねる。
 *
 *  使用例:
 *    const t = useLabel();
 *    <label>{t('field.employees.employee_number', '社員番号')}</label>
 */
export const useLabel = () => {
  const { data } = useQuery<Record<string, string>>({
    queryKey: ['labels'],
    queryFn: () => apiFetch<Record<string, string>>('/labels'),
    staleTime: 10 * 60_000,
  });
  return (key: LabelKey, fallback: string) => data?.[key] ?? fallback;
};
